module.exports = ".cut-intro, .numbering-text {\n    max-width: 550px;\n    margin: 0 20px 0;\n}\n\n.right {\n    float: right;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/help/help.component.css
// module id = ./src/app/help/help.component.css
// module chunks = main